import axios from '../../services/api-axios';
import styles from './OnlineUsers.module.css';

const inviteUser = (user: string, lobbyId: string): void => {
    axios.post("/rest/lobby/invite", {
        invitee: user,
        lobbyId: lobbyId
    }).catch(error => {
        console.error(error);
    });
};

interface OnlineUsersProps {
    users: string[];
    lobbyId?: string;
}

const OnlineUsers = ({ users, lobbyId }: OnlineUsersProps) => {
    return (
        <div className={styles.list}>
            {users.map((user) => (
                <div key={user} className={styles.row}>
                    <div className={styles.identity}>
                        <div className={styles.avatar}>{user.charAt(0).toUpperCase()}</div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                            <div className={styles.name}>{user}</div>
                            <div className={styles.statusRow}>
                                <div className={styles.statusDot} />
                                Online
                            </div>
                        </div>
                    </div>

                    {lobbyId && (
                        <button className={styles.inviteButton} onClick={() => inviteUser(user, lobbyId)}>
                            Invite
                        </button>
                    )}
                </div>
            ))}
        </div>
    );
};

export default OnlineUsers;
